<template>
  <div>
    <!--<a-modal v-if="(UserMenu == 'CODE' || UserMenu == '') && !ConsentAccepted" v-model="ConsentVisible" centered -->
    <a-modal v-if="IsShowConsent && !ConsentAccepted" v-model="IsShowConsent" centered :closable="false"
      :maskClosable="false" :keyboard="false" :footer="null" :width="680"
      wrapClassName="consent-modal animate__animated animate__zoomInDown animate__fast" :bodyStyle="{ padding: 0 }">
      <div class="consent-box">
        <div class="consent-box__header">
          <a-icon type="safety-certificate" />
          <div>
            <h3>CHÍNH SÁCH THU THẬP THÔNG TIN CÁ NHÂN</h3>
            <p>Chào mừng Quý khách hàng đến với Chương trình khuyến mại <b>“BẬT TIỆC SỐNG ĐỘNG TRÚNG NGÀN QUÀ
                CHILL”</b>.<br />
              Bằng việc điền và gửi biểu mẫu này, Quý khách xác nhận và đồng ý rằng:</p>
          </div>

          <!-- <div>
            <h3>CHÍNH SÁCH THU THẬP THÔNG TIN CÁ NHÂN</h3>
            <p>Chào mừng Quý khách hàng đến với Chương trình khuyến mại:</p>
            <div class="SBC_Promotion_name">“BẬT TIỆC SỐNG ĐỘNG TRÚNG NGÀN QUÀ CHILL”</div>.
            <p>Bằng việc điền và gửi biểu mẫu này, Quý khách xác nhận và đồng ý rằng:</p>
          </div> -->
        </div>

        <div class="consent-box__content">
          <h4>1. Mục đích thu thập thông tin</h4>
          <p>
            Thông tin được Quý khách cung cấp sẽ được sử dụng cho các mục đích:
          <ul class="ps-4 mb-3">
            <li class="mb-1">Xác minh thông tin và hỗ trợ Quý khách tham gia CTKM.</li>
            <li class="mb-1">Liên hệ, thông báo và hỗ trợ các nội dung liên quan đến CTKM.</li>
            <li class="mb-1">Xác nhận kết quả, xử lý việc nhận và trao thưởng theo thể lệ CTKM (nếu có).</li>
            <li>Gửi thông báo, thông tin về CTKM và các nội dung liên quan.</li>
            <li>Hỗ trợ chăm sóc khách hàng và cải thiện chất lượng trải nghiệm của người tham gia.</li>
          </ul>
          </p>

          <h4>2. Phạm vi sử dụng thông tin</h4>
          <p>
            Thông tin cá nhân được thu thập chỉ được sử dụng cho các hoạt động liên quan đến việc tổ chức, vận hành và
            hỗ trợ cho CTKM.
          </p>
          <p>
            Thông tin có thể được chia sẻ với các đơn vị, đối tác có liên quan trực tiếp đến việc tổ chức, vận hành, xác
            minh và trao thưởng của CTKM khi cần thiết, với điều kiện tuân thủ các quy định pháp luật hiện hành về bảo
            vệ dữ liệu cá nhân.</p>
          <h4>3. Quyền của người cung cấp thông tin</h4>
          <p>
            Quý khách có quyền:
          </p>
          <ul class="ps-4 mb-3">
            <li class="mb-1"><p>Có quyền yêu cầu xem, kiểm tra hoặc chỉnh sửa thông tin cá nhân đã cung cấp.</p></li>
            <li class="mb-1"><p>Có quyền rút lại sự đồng ý đối với việc xử lý thông tin cá nhân bằng cách liên hệ với đơn
              vị tiếp nhận và quản lý thông tin.
          </p></li>
          </ul>
          <p>Việc rút lại sự đồng ý có thể ảnh hưởng đến khả năng tiếp tục tham gia hoặc nhận các quyền lợi liên quan
            đến CTKM trong trường hợp thông tin đó là cần thiết để xác minh người tham gia hoặc thực hiện việc trao
            thưởng.</p>
          <h4>4. Thời gian lưu trữ</h4>
          <p>
            Dữ liệu cá nhân của Quý khách sẽ được lưu trữ từ khi hệ thống ghi nhận đến khi hoàn tất việc trao thưởng của
            CTKM, hoặc lưu trữ theo thời hạn quy định của pháp luật về kế toán/thuế.
          </p>

          <h4>5. Cam kết bảo mật</h4>
          <p>
            Thông tin cá nhân của Quý khách được bảo mật, lưu trữ an toàn và xử lý tuân thủ nghiêm ngặt theo các quy
            định pháp luật hiện hành của Việt Nam về bảo vệ dữ liệu cá nhân. Các biện pháp cần thiết và phù hợp sẽ được
            áp dụng nhằm hạn chế việc truy cập, sử dụng, thay đổi hoặc tiết lộ thông tin trái phép.
          </p>
          <h4>6. Xác nhận đồng ý</h4>
          <p>
            Bằng việc đánh dấu "Đồng ý", nhấn nút "Gửi" hoặc tiếp tục cung cấp thông tin để tham gia CTKM, Quý khách xác
            nhận rằng đã đọc, hiểu và đồng ý với các nội dung về thu thập, sử dụng và bảo vệ thông tin cá nhân được nêu
            trên.
          </p>
          <p>
            Cảm ơn Quý khách đã quan tâm và tham gia Chương trình khuyến mại “BẬT TIỆC SỐNG ĐỘNG TRÚNG NGÀN QUÀ CHILL”.
            Kính chúc Quý khách có những trải nghiệm thú vị cùng Chương trình.
          </p>
        </div>

        <div class="consent-box__footer">
          <a-checkbox v-model="ConsentChecked">
            Tôi xác nhận đã đọc, hiểu và đồng ý với Thể lệ chương trình,
            Điều khoản tham gia và việc xử lý dữ liệu cá nhân nêu trên.
          </a-checkbox>

          <div v-if="ConsentError" class="field-error">
            {{ ConsentError }}
          </div>

          <a-button type="primary" block class="consent-continue" :disabled="!ConsentChecked" @click="AcceptConsent">
            TIẾP TỤC
          </a-button>
        </div>
      </div>
    </a-modal>
    <a-modal v-model="isRuleOpen" title="THỂ LỆ CHƯƠNG TRÌNH" centered :footer="null" width="auto"
      style="padding-top:50px;width:100%;max-width: 1000px;" :bodyStyle="{ padding: 0 }" wrapClassName="modalRule">
      <div class="image-list">
        <div v-for="(img, index) in lstRuleImage" :key="index" class="image-item">
          <img :src="img" alt="Ảnh" />
        </div>
      </div>
    </a-modal>
    <a-modal v-model="isHelpOpen" title="HƯỚNG DẪN" centered :footer="null" width="auto"
      style="padding-top:50px;width:400px;max-width: 1000px;" :bodyStyle="{ padding: 0 }" wrapClassName="modalRule">
      <!-- <div class="image-list">
        <div v-for="(img, index) in lstHelpImage" :key="index" class="image-item">
          <img :src="img" alt="Ảnh" />
        </div>
      </div> -->
      
          <p>Để nhập mã tham gia chương trình, quý khách vui lòng xem video hướng dẫn dưới đây:</p>
          <p>Hoặc liên hệ hotline  <a style="color:#00507a;" class="text-non-shadow" :href="`tel:${this.$PRJ_PHONE}`"><i
                  class="fa fa-phone-square" aria-hidden="true"></i>
                {{ this.$PRJ_PHONE.replace("1900", "1900 ") }}</a> để được hỗ trợ.</p>
      <Mp4Player width="100%" :src="TutoralVideo" :poster="Poster" />
    </a-modal>

    <a-modal class="history-modal" v-model="HistoryVisible" title="Lịch sử nhập mã" :footer="null" :width="650"
      centered>
      <a-table row-key="STT" size="small" :locale="{
        emptyText: HistoryLoading
          ? 'Đang tải dữ liệu...'
          : 'Không có dữ liệu phù hợp'
      }" :columns="HistoryColumns" :data-source="HistoryData" :pagination="false" :loading="HistoryLoading">
        <template slot="HistoryDate" slot-scope="text, record">
          <div>{{ FormatDate(record.Created_At) }}</div>

          <div class="history-time">
            {{ FormatTime(record.Created_At) }}
          </div>
        </template>

        <template slot="HistoryCode" slot-scope="text, record">
          <strong>
            {{ MaskScratchCode(record.Scratch_Code) }}
          </strong>
        </template>

        <template slot="HistoryStatus" slot-scope="text, record">
          <a-tag :color="GetStatus(record).Color">
            {{ GetStatus(record).Text }}
          </a-tag>
        </template>
      </a-table>

      <div v-if="HistoryPagination.Total > 0" class="history-pagination">
        <a-pagination size="small" :current="HistoryPagination.Page" :page-size="HistoryPagination.PageSize"
          :total="HistoryPagination.Total" :show-size-changer="false" @change="HistoryPageChange" />
      </div>
    </a-modal>
    <!-- <div style="position: absolute; top: 20px; right: 10px;z-index:9999999">
      <img src="../assets/logo.png" alt="" style="width: 50px;">
    </div> -->
    <div v-if="!IsConfirmAge" id="confirm-age" class="container-fluit"
      style="height: 100vh; background: rgba(191, 191, 191, 0.3);">
      <div id="noticePopup" :class="IsUnder18 ? 'popup-dialog open' : 'popup-dialog'">
        <div class="popup-global"><a href="#!" @click="IsUnder18 = false" class="popup-close close"><span
              class="lnr lnr-cross">X</span></a>
          <div class="popup--content text-center">Xin lỗi bạn vì sự bất tiện này, vui lòng ghé thăm Website của chúng
            tôi khi bạn đã đủ 18 tuổi.</div>
        </div>
      </div>
      <a-row
        style="margin-left:unset!important;margin-right:unset!important;height: 90%; align-items: center;display:flex">
        <a-col :xs="0" :sm="0" :md="0" :lg="6"></a-col>
        <a-col :xs="24" :sm="24" :md="24" :lg="12">
          <div style="width:100%;height: 500;text-align:center;background: none;background-size: 100% 100% !important;"
            class=" animate__animated animate__bounceIn  animate__fast">
            <div class="position-relative">
              <section class="agegatefrm text-xs-center clearfix">
                <h1 class="confirmAge-title">
                  <span>TỔNG CÔNG TY CỔ PHẨN<br>BIA - RƯỢU - NƯỚC GIẢI KHÁT SÀI GÒN</span><br><br>
                </h1>
                <a-space wrap>
                  <a-button type="button" @click="() => { IsConfirmAge = true; IsOver18Confirm = true; }"
                    class="confirmage_button">Tôi đã đủ 18
                    tuổi</a-button>
                  <a-button type="button" @click="IsUnder18 = true" class="confirmage_button open--popup">Tôi chưa đủ
                    18 tuổi</a-button>
                </a-space>
                <div class="intro-languages"><br>
                </div>
                <div class="agreetext animate__animated animate__pulse  animate__delay-1s">SABECO cam kết uống có trách
                  nhiệm. Đó là lý do tại
                  sao chúng tôi cần
                  phải đảm bảo rằng bạn đang ở trên tuổi uống bia rượu hợp pháp và bạn được phép về mặt pháp
                  lý để xem trang web này. Khi nhấn xác nhận "Tôi đã đủ 18 tuổi" đồng nghĩa với việc bạn xác
                  nhận mình trong độ tuổi uống bia rượu hợp pháp. Nếu chưa đủ tuổi uống bia rượu hợp pháp, xin
                  vui lòng ghé thăm trang của chúng tôi khi bạn đã đủ 18 tuổi.</div>
              </section>
            </div>
          </div>
        </a-col>
        <a-col :xs="0" :sm="0" :md="0" :lg="6"></a-col>
      </a-row>
    </div>
    <a-row v-else class="right_panel">
      <a-col :xs="24" :sm="24" :md="10" :lg="12" :xl="14">
        <!-- <a-row>
          <a-col style='min-height: 0px;' :xs="24" :sm="24" :md="24" :lg="24">
            <img class="bg-logo animate__animated animate__rubberBand animate__fast" src='../assets/banner.png' />
          </a-col>
        </a-row> -->
        <a-row>
          <a-col v-if="this.$POSTER_TYPE == 'BOTTOM_ABSOLUTE'" :xs="24" :sm="24" :md="24" :lg="24"
            style="position: absolute;">
            <img class="bg-absolute animate__animated animate__fadeIn  animate__faster" src='../assets/poster.png' />
          </a-col>
          <a-col v-if="this.$POSTER_TYPE == 'CENTER'" :xs="24" :sm="24" :md="24" :lg="24">
            <img class="bg-center animate__animated animate__tada  animate__faster" src='../assets/poster.png' />
          </a-col>
        </a-row>
      </a-col>
      <a-col style="padding:5px" :xs="24" :sm="24" :md="14" :lg="12" :xl="10"
        class="right_card animate__animated animate__fadeIn animate__delay-1s">
        <a-row>
          <a-col :xs="0" :sm="0" :md="1" :lg="2" :xl="2"></a-col>
          <a-col :xs="24" :sm="24" :md="22" :lg="20" :xl="20">
            <br />
            <a v-if="UserMenu == 'CODE'"
          href="/?Page=REWARD_LIST"
          class="reward-list-link"
          >
          DANH SÁCH TRÚNG GIẢI NHÌ
        </a>
        <br v-else/>
            <fish-card v-if="IsNotYet" class="fliptime" fluid style="border-radius: 10px;border: #00507a 2px solid;">
              <div slot="header">CHƯƠNG TRÌNH BẮT ĐẦU SAU:</div>
              <div id="flipdown" ref="flipdown" class="flipdown"></div>
              <div slot="footer">Qúy khách vui lòng chờ đến khi chương trình bắt đầu.
                <a-row>
                    <a-col :span="12">
                      <a-form-item>
                        <a-button @click="isRuleOpen = true" class="sbc-button">THỂ LỆ</a-button>
                      </a-form-item>
                    </a-col>
                    <a-col :span="12">
                      <a-form-item>
                        <a-button @click="isHelpOpen = true" class="sbc-button">HƯỚNG DẪN GIẢI NHÌ</a-button>
                      </a-form-item>
                    </a-col>
                    </a-row>
                <!-- <a-form-item>
                  <a-button @click="isRuleOpen = true" class="sbc-button" style="width:300px">THỂ LỆ CHƯƠNG
                    TRÌNH</a-button>
                </a-form-item> -->
              </div>
            </fish-card>
            <fish-card v-else fluid style="border-radius: 10px;border: #00507a 2px solid;">
              <fish-loader :active="isLoadingTBL"></fish-loader>
              <div slot="header"><fish-button @click="onBack2Code" v-if="UserMenu != 'CODE' && UserMenu != 'RESPONSE'"
                  style="font-size: 20px !important;padding:0.3rem 0.6rem"><i
                    class="fa fa-chevron-left"></i></fish-button>
                {{ !ConsentAccepted ? 'ĐIỀU KHOẢN THAM GIA' : oMenuData.Title }}<div
                  v-if="UserMenu != 'CODE' && UserMenu != 'RESPONSE'" style="width:30px;display:inline-block"></div>
              </div>
              <a-form class='form-code' v-if="UserMenu == 'CODE'" layout="vertical">
                <div v-if="!ConsentAccepted">
                  <a-alert type="warning" show-icon class="voucher-alert">
                    <template slot="message">
                      <strong>Vui lòng đọc và đồng ý với điều khoản để tham gia chương trình.</strong>
                    </template>

                    <template slot="description">
                      <div class="voucher-alert__content">
                        <a-button style="margin-left: -50px;" type="primary" size="small" @click="OpenConsent">
                          Xem điều khoản
                        </a-button>
                      </div>
                    </template>
                  </a-alert>
                </div>
                <div v-if="IsOver18Confirm === true && ConsentAccepted === true">
                  <p style="font-family: inherit;color:black;text-align: left;margin-bottom:0">Quý khách vui lòng nhập
                    thông tin yêu
                    cầu bên dưới:</p>

                  <div class="award-divider" style="    margin-top: 0px;">
                    <span class="award-divider__title">
                      THÔNG TIN KHÁCH HÀNG
                    </span>
                  </div>
                  <!-- <a-divider orientation="left" class="text-left" style="margin: 5px 0!important"> THÔNG TIN KHÁCH HÀNG
                  </a-divider> -->
                  <a-row class="text-left">
                    <a-col :xs="14" :sm="13">
                      <a-form-item label="Họ và tên:" :class="{
    'submit-field-error':
      SubmitAttempted &&
      String(FullName || '').trim().length < 2
  }">
                        <a-input v-model="FullName" placeholder="Vui lòng nhập Họ và tên" :maxLength=60
                          @blur="NormalizeFullName" />
                      </a-form-item>
                    </a-col>
                    <a-col :xs="10" :sm="11">
                      <a-form-item label="Ngày sinh:" :class="{
    'submit-field-error':
      SubmitAttempted &&
      !DoB
  }">
                        <date-input v-model="DoB" :minimum-age="18" :maximum-age="100" required />
                        <!-- <a-date-picker v-model="DoB" style="width:100%!important" placeholder="Chọn ngày sinh"
                          format="DD/MM/YYYY" value-format="YYYY-MM-DD" :disabled-date="DisableBirthday"
                          :show-today="false" /> -->
                      </a-form-item>
                    </a-col>
                  </a-row>
                  <a-row class="text-left">
                    <a-col :span="24">
                      <a-form-item label="Địa chỉ:" :class="{
    'submit-field-error':
      SubmitAttempted &&
      String(Address || '').trim().length < 20
  }">
                        <a-input
                          v-model="Address"
                          placeholder="Vui lòng nhập địa chỉ"
                          :maxLength="300"
                        >
                          <a-icon
                            slot="prefix"
                            type="environment"
                          />
                        </a-input>
                      </a-form-item>
                    </a-col>
                  </a-row>
                  <a-row class="text-left">
                    <a-col :span="16">
                      <a-form-item label="Số điện thoại:" :validate-status="PhoneStatus" :help="PhoneError">
                        <a-input :disabled="OTPVerified" :value="Phone" @input="validatePhone($event.target.value)"
                          placeholder="Nhập số điện thoại (10 số, 0xxxxxxxxx)" :maxLength=10 inputmode="numeric"
                          pattern="[0-9]*">
                          <a-icon slot="prefix" type="phone" />
                        </a-input>
                      </a-form-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-item>

                        <template slot="label">
                          <span>&nbsp;</span>
                        </template>
                        <a-button v-if="!OTPVerified" :disabled="!canSendOTP" @click="SendOTP"
                          class="sbc-button" :loading="SendingOTP" block>
                          {{ ResendSeconds > 0 ? `${ResendSeconds}s` : 'GỬI OTP' }}</a-button>
                      </a-form-item>
                    </a-col>
                  </a-row>
                  <a-row v-if="OTPSent && !OTPVerified" class="text-left">
                    <a-col :span="16">
                      <a-form-item label="Mã OTP">
                        <a-input :value="OTPCode" :maxLength="6" inputmode="numeric" placeholder="Nhập mã OTP"
                          @input="ValidateOTP($event.target.value)" @pressEnter="VerifyOTP">
                          <a-icon slot="prefix" type="safety" />
                        </a-input>
                      </a-form-item>
                    </a-col>

                    <a-col :span="8">
                      <a-form-item>
                        <template slot="label">
                          <span>&nbsp;</span>
                        </template>
                        <a-button type="primary" block class="button-height" :loading="VerifyingOTP"
                          :disabled="!CanVerifyOTP" @click="VerifyOTP">
                          XÁC THỰC
                        </a-button>
                      </a-form-item>
                    </a-col>
                  </a-row>

                  <a-alert v-if="OTPMessage" :type="OTPMessageType" show-icon class="form-alert"
                    :message="OTPMessage" />
                  <template v-if="OTPVerified">
                    <div class="award-divider">
                      <span class="award-divider__title">
                        THÔNG TIN DỰ THƯỞNG
                      </span>

                      <span class="award-divider__countdown" :class="{
                        'award-divider__countdown--warning':
                          CountdownSeconds >= 0 &&
                          CountdownSeconds <= 60
                      }">
                        <img src="@/assets/alarm.svg" alt="" class="countdown-alarm-icon" :class="{
                          'countdown-alarm-icon--urgent':
                            CountdownSeconds >= 0 &&
                            CountdownSeconds <= 60
                        }" />
                        <span class="countdown-label">
                          Hoàn tất trong
                        </span>
                        <strong>{{ CountdownText }}</strong>
                      </span>
                    </div>
                    <!-- <a-divider orientation="left" style="margin: 5px 0!important" class="award-divider-ant">
                      <div class="award-divider-ant__content">
                        <span class="award-divider__title">
                          THÔNG TIN DỰ THƯỞNG
                        </span>

                        <span class="award-divider__countdown">
                          <a-icon type="clock-circle" />
                          Hoàn tất trong
                          <strong>{{ CountdownText }}</strong>
                        </span>
                      </div>
                    </a-divider> -->
                    <!-- <a-divider orientation="left" class="text-left" style="margin: 5px 0!important"> THÔNG TIN DỰ THƯỞNG
                    </a-divider>
                    <div v-if="CountdownSeconds > 0" class="session-countdown" :class="{
                      'session-countdown--warning':
                        CountdownWarning
                    }">
                      <span>Thời gian nhập thông tin còn lại</span>

                      <strong>{{ CountdownText }}</strong>
                    </div> -->
                    <a-form-item label="Mã dự thưởng lấy từ">
                      <a-radio-group v-model="CODE_TYPE" class="code-type-radio" :class="{
                        'code-type-radio--attention': !CODE_TYPE
                      }" :disabled="!OTPVerified" @change="ChangeCodeType">
                        <a-radio-button value="CAP">
                          <img :src="CapIcon" alt="Nắp chai" class="code-type-radio__image" />
                          <div>Nắp chai</div>
                        </a-radio-button>

                        <a-radio-button value="TAB">
                          <img :src="TabIcon" alt="Khoén lon" class="code-type-radio__image" />
                          <div>Khoén lon</div>
                        </a-radio-button>
                      </a-radio-group>
                      <!-- <a-radio-group v-model="CODE_TYPE" :disabled="!OTPVerified" @change="ChangeCodeType">
                        <a-radio value="CAP"> Nắp chai </a-radio>
                        <a-radio value="TAB"> Khoén lon </a-radio>
                      </a-radio-group> -->

                      <div class="field-help">
                        {{ CodeTypeMessage }}
                      </div>
                    </a-form-item>
                  </template>
                  <template v-if="OTPVerified && CODE_TYPE">
                    <a-row class="text-left">
                      <a-col :span="24">
                        <a-form-item label="Mã trúng thưởng:" :class="{
    'submit-field-error':
      SubmitAttempted &&
      String(ScratchCode || '').length !== CODE_LENGTH
  }">
                          <Scratch_Input v-model="ScratchCode" :Length="CODE_LENGTH"
                            :StartLetterArray="this.$PRJ_LETTER" :disabled="!OTPVerified" />
                        </a-form-item>
                      </a-col>
                    </a-row>

                    <a-row>
                      <a-col :xs="24" :sm="12">
                        <a-form-item label="Hình ảnh nắp/khoén:" :class="{
    'submit-field-error':
      SubmitAttempted &&
      !CodeImage
  }">
                          <upload-image v-model="CodeImage" :placeholder-image="RewardCodePlaceholder" label=""
                            button-text="Hình ảnh nắp/khoén trứng thưởng" required :disabled="!OTPVerified" />
                        </a-form-item>
                      </a-col>

                      <a-col :xs="24" :sm="12">
                        <a-form-item label="Hình ảnh CCCD (mặt trước):"
  :class="{
    'submit-field-error':
      SubmitAttempted &&
      !IdentityImage
  }">
                          <upload-image v-model="IdentityImage" :placeholder-image="IdentityPlaceholder" label=""
                            button-text="Hình ảnh CCCD (Mặt trước)" required :disabled="!OTPVerified" />
                        </a-form-item>
                      </a-col>
                    </a-row>

                  </template>
                  <a-row class="text-left">
                    <a-col :span="24">
                      <a-form-item label="Xác minh người dùng:">
                        <!-- <div
                          class="cf-turnstile"
                          data-sitekey="0x4AAAAAACyeuhyTZG5Q7gaL"
                          data-callback="onCaptchaSuccess">
                        </div> -->
                        <div class="turnstile-wrap">
                          <div ref="captcha"></div>
                        </div>

                        <!-- <div ref="captchaV2" class="g-recaptcha"></div> -->
                      </a-form-item>
                    </a-col>
                  </a-row>

                  <template v-if="OTPVerified">
                    <a-alert v-if="SubmitMessage" type="error" show-icon class="form-alert" :message="SubmitMessage" />
                    <a-row class="text-left">
                      <a-col :span="24">
                        <a-form-item>
                          <a-button @click="SubmitReward" class="sbc-button sbc-bigbutton">NHẬN
                            THƯỞNG</a-button>
                        </a-form-item>
                      </a-col>
                    </a-row>
                  </template>
                </div>
                <div v-else-if="IsOver18Confirm === false" class="age-warning">
                  Chương trình chỉ dành cho khách hàng từ 18 tuổi trở lên. Mong Quý Khách Thông Cảm
                </div>
                <div>
                  <a-row class="text-left">
                    <a-col :span="12">
                      <a-form-item>
                        <a-button @click="isRuleOpen = true" class="sbc-button">THỂ LỆ</a-button>
                      </a-form-item>
                    </a-col>
                    <a-col :span="12">
                      <a-form-item>
                        <a-button @click="isHelpOpen = true" class="sbc-button">HƯỚNG DẪN GIẢI NHÌ</a-button>
                      </a-form-item>
                    </a-col>
                  </a-row>
                </div>
              </a-form>

              <a-form class='form-code' v-if="UserMenu == 'REWARD_LIST'" layout="vertical">
                <RewardList />
              </a-form>
              <a-form class='form-code' v-if="UserMenu == 'REWARD_LOCATION'" layout="vertical">
                <RewardPage />
              </a-form>

              <a-table :locale="{ emptyText: 'Không có dữ liệu phù hợp' }" v-if="UserMenu == 'RESULT'" rowKey="STT"
                size="small" :columns="TBLcolumns" :data-source="TBLdata" :pagination="false">
                <template slot="STT" slot-scope="text">{{ text }}</template>
                <template slot="Request_Time" slot-scope="text">{{ text | moment("DD/MM/YYYY HH:mm:ss") }}</template>
                <template slot="Scratch_Status" slot-scope="text">
                  <a-tag :color="text == 'Success' ? 'green' : text == 'Duplicate' ? 'orange' : 'red'">{{ text ==
                    'Success' ? 'Thành công' : text == 'Duplicate' ? 'Mã trùng' : 'Không chính xác'
                    }}</a-tag>
                </template>
              </a-table>
              <a-form class="form-code" v-if="UserMenu == 'RESPONSE'" style="padding:10px 5px;">
                <Scratch_Response :MT_Message="oResponseData.MT_Message"
                  :Scratch_Status="oResponseData.Scratch_Status" />
              </a-form>
              <div slot="footer" v-if="['RESULT', 'RESPONSE', 'CODE'].includes(UserMenu)"
                :style="UserMenu == 'CODE' ? 'text-align:left;' : ''">

                <a-button v-if="UserMenu == 'RESPONSE'" style="width: 300px;height:40px" @click="onBack2Code"
                  class="sbc-button">{{
                    IsReset_VerifyPhone ? "XÁC MINH THÔNG TIN" : 'NHẬP MÃ TRÚNG THƯỞNG' }}</a-button>
                <a-pagination v-if="UserMenu == 'RESULT'" size="medium" :showLessItems="true" :pageSize="10"
                  @change="fillData" :total="TotalCount" />

                <a-row v-if="['RESULT', 'CODE'].includes(UserMenu)">
                  <a-col class="text-left" :span="12">
                    <a style="font-size:14px" href="/?Page=REWARD_LOCATION" click>KHU VỰC KHUYẾN MÃI</a>
                  </a-col>
                  <a-col class="text-right" :span="12">
                    <a style="font-size:14px" v-if="OTPVerified" @click.prevent="OpenHistoryModal" click>LỊCH SỬ NHẬP
                      MÃ</a>
                  </a-col>
                </a-row>
                <!-- <div class="text-left" v-if="['RESULT', 'CODE'].includes(UserMenu)"><a href="/?Page=FIND" click>
                    Tra cứu số điện thoại
                  </a></div> -->
              </div>
            </fish-card>
          </a-col>
          <a-col :xs="0" :sm="0" :md="1" :lg="2" :xl="2"></a-col>
        </a-row>
        <a-row style='padding-top:20px; text-shadow: 2px 2px 2px black;'>
          <a-col span="12" style="padding: 0 5px;">
            <div class="text-floralwhite text-left">Tìm mã trúng thưởng dưới khoén lon hoặc nắp chai để tham gia
              chương trình
            </div>
            <hr style="padding: 0;margin: 2px 0;">
            <div class="text-floralwhite text-uppercase text-left">Thời hạn đổi thưởng:
              {{ this.$START_DATE | moment("DD/MM/YYYY") }} -
              {{ this.$END_DATE | moment("DD/MM/YYYY") }}</div>
            <hr style="padding: 0;margin: 2px 0;">
            <div class="text-floralwhite text-left">(*) Hình ảnh quà tặng chỉ mang tính chất minh họa
            </div>
          </a-col>
          <a-col span="12" style="padding: 0 5px;">
            <div class="text-floralwhite text-left">NGƯỜI DƯỚI 18 TUỔI KHÔNG ĐƯỢC UỐNG RƯỢU, BIA</div>
            <div class="text-floralwhite text-left">ĐÃ UỐNG RƯỢU BIA - KHÔNG LÁI XE</div>
            <div class="text-floralwhite text-left">Nồng độ cồn: {{ this.$PRJ_ALCOHOL }}</div>
            <div class="text-floralwhite text-left">Liên hệ:</div>
            <div
              style="width: 130px;line-height:22px;height: 22px;text-align:center;color:green;font-weight:bold;border-top-right-radius: 250px;border-bottom-right-radius: 250px;background-color: white">
              <a style="color:#00507a;" class="text-non-shadow" :href="`tel:${this.$PRJ_PHONE}`"><i
                  class="fa fa-phone-square" aria-hidden="true"></i>
                {{ this.$PRJ_PHONE.replace("1900", "1900 ") }}</a>
            </div>
          </a-col>
        </a-row>


      </a-col>
    </a-row>
  </div>
</template>
<script>

/* global FlipDown */
import moment from 'moment'
import 'flipdown/dist/flipdown.css';
import { mapActions } from "vuex";
import axios from 'axios';
import RewardPage from "@/components/RewardPage.vue"
import RewardList from "@/components/RewardList.vue"
import UploadImage from '@/components/UploadImage.vue'
import DateInput from '@/components/DateInput.vue'
import RewardCodePlaceholder from '@/assets/scratch-holder.png'
import Poster from '@/assets/poster.png'
import IdentityPlaceholder from '@/assets/cccd-holder.png'
import TutoralVideo from '@/assets/tutorial.mp4'
import CapIcon from '@/assets/cap.jpg'
import TabIcon from '@/assets/tab.jpg'
export default {
  components: {
    RewardPage,
    RewardList,
    UploadImage,
    DateInput
  },
  computed: {

    /*
     * DLR chỉ bật khi main.js set Vue.prototype.$IS_DLR = true.
     * PLSTEST luôn ép bật DLR để test.
     */
    IsDLREnabled() {
      return true
      // return (
      //   this.$IS_DEV === true ||
      //   Number(this.$IS_DEV) === 1 ||
      //   this.$IS_DLR === true ||
      //   Number(this.$IS_DLR) === 1
      // )
    },

    CODE_LENGTH() {
      switch (this.CODE_TYPE) {
        case 'CAP':
          return 5

        case 'TAB':
          return 6

        default:
          return 0
      }
    },
    CountdownText() {
      const seconds = this.CountdownSeconds

      const minutes = Math.floor(
        seconds / 60
      )

      const remainSeconds = seconds % 60

      return (
        String(minutes).padStart(2, '0') +
        ':' +
        String(remainSeconds).padStart(2, '0')
      )
    },
    CodeTypeMessage() {
      switch (this.CODE_TYPE) {
        case 'CAP':
          return 'Vui lòng nhập mã gồm 5 ký tự được in bên dưới nắp chai.'

        case 'TAB':
          return 'Vui lòng nhập mã gồm 6 ký tự được in trên khoén lon.'

        default:
          return 'Vui lòng chọn mã dự thưởng được lấy từ nắp chai hoặc khoén lon.'
      }
    },
    isValidPhone() {
      return /^0\d{9}$/.test(this.Phone || '');
    },
    isScratchComplete() {
      //) && this.$PRJ_LETTER.includes(this.ScratchCode[0]) Check ky tu dau
      return ((this.ScratchCode || '').length === (this.CODE_LENGTH || 0));
    },

    canSendOTP() {
      return (
        this.ConsentAccepted &&
        /^0\d{9}$/.test(this.Phone) &&
        (this.$IS_DEV || Boolean(this.TurnstileToken)) &&
        !this.OTPVerified &&
        !this.SendingOTP &&
        this.ResendSeconds === 0
      )
    },

    CanVerifyOTP() {
      return (
        this.OTPSent &&
        /^\d{4,6}$/.test(this.OTPCode) &&
        !this.OTPVerified &&
        !this.VerifyingOTP
      )
    },

    CanSubmitReward() {
      return (
        this.OTPVerified &&
        this.IsOver18Confirm && this.ConsentAccepted &&
        this.FullName.trim().length >= 2 &&
        this.DoB &&
        this.Address.trim().length >= 20 &&
        this.ScratchCode.length === this.CODE_LENGTH &&
        this.CodeImage &&
        this.IdentityImage &&
        (this.$IS_DEV || Boolean(this.TurnstileToken)) &&
        !this.SubmittingReward
      )
    }
    // canRedeem() {
    //   return (
    //     this.IsOver18Confirm === true &&
    //     this.isValidPhone &&
    //     this.isScratchComplete
    //     && (!this.showV2 || (this.showV2 && this.v2Token))
    //   );
    // }
  },
  watch: {
    Phone(newVal) {
      this.validatePhone(newVal);
    },

    async IsConfirmAge(newVal) {
      if (newVal == true) {
        if (this.UserMenu == "") {
          this.UserMenu = "CODE"
        }
        await this.$nextTick(async () => {
          let serverTimestamp = 0;
          const clientTimestamp = moment().unix();

          try {
            const res = await axios.get(this.$PRJ_DOMAIN_WS + '/getnowtime', { timeout: 1000 });
            if (res.data.State === 1 && res.data.Message) {
              serverTimestamp = moment(res.data.Message, 'YYYY-MM-DD HH:mm:ss').unix();
            } else {
              serverTimestamp = clientTimestamp;
            }
          } catch {
            serverTimestamp = clientTimestamp;
          }
          const startTimestamp = moment(this.$START_DATE, 'YYYY-MM-DD HH:mm:ss').unix();

          // Tính thời gian countdown dựa trên giờ server
          const countdownFrom = startTimestamp - serverTimestamp;

          if (countdownFrom > 0) {
            new FlipDown(serverTimestamp + countdownFrom, { headings: ["Ngày", "Giờ", "Phút", "Giây"] }).start();
            this.$nextTick(() => {
              const labels = this.$refs.flipdown.querySelectorAll('.flipdown__label');
              const vietLabels = ['Ngày', 'Giờ', 'Phút', 'Giây'];
              labels.forEach((labelEl, i) => {
                if (vietLabels[i]) labelEl.textContent = vietLabels[i];
              });
            });
            // this.ConsentVisible = false;
          } else {
            this.IsNotYet = false;
            // this.ConsentVisible = true;
          }
        });
      }
    }
  },
  async mounted() {
    try {
      // Dùng require.context để load ảnh từ thư mục
      const requireImage = require.context(
        "@/assets/rule",
        false, // không load subfolder
        /\.(png|jpe?g|gif|webp)$/
      );

      this.lstRuleImage = requireImage.keys().map(requireImage);
      const helpImage = require.context(
        "@/assets/help",
        false, // không load subfolder
        /\.(png|jpe?g|gif|webp)$/
      );

      this.lstHelpImage = helpImage.keys().map(helpImage);
      // this.$route.query
      if ("Page" in this.$route.query) {
        if (['CODE', 'RESULT', 'REWARD_LOCATION','REWARD_LIST', 'RESPONSE'].includes(this.$route.query.Page))
          this.SelectMenu(this.$route.query.Page)
      }
      else {
        this.oMenuData = this.lstMenuData.find(st => st.Type == "CODE")
        // this.SelectMenu("CODE")
      }
      if (this.UserMenu !== "") {
        this.ConsentAccepted = true
        this.IsConfirmAge = true

      }
      // const interval = setInterval(() => {
      //     if (window.turnstile) {
      //       clearInterval(interval)
      //       this.RenderTurnstile()
      //     }
      //   }, 200)
      // this.$nextTick(() => {
      //   // this.RenderTurnstile();
      // });

    } catch (error) {
      if(this.$IS_DEV)
      console.log("Mounted Err:" + error.message)
    }

    // try {
    //   const res = await axios.get('http://116.109.45.138:8082/getnowtime', { timeout: 1000 });
    //   if (res.data.State === 1 && res.data.Message) {
    //     this.nowTime = res.data.Message;
    //   } else {
    //     throw new Error('Invalid response');
    //   }
    // } catch {
    //   const now = new Date();
    //   this.nowTime = now.toISOString().slice(0, 19).replace('T', ' ');
    // }

  },
  beforeDestroy() {
    this.StopSessionCountdown()
    this.RemoveTurnstile()
  },
  data() {
    return {


      ScratchCodeCells: [],

      CODE_TYPE: "",
      CodeImage: null,
      IdentityImage: null,

      SessionExpiredAt: null,
      CountdownSeconds: 0,
      CountdownTimer: null,
      SessionExpired: false,

      IsShowConsent: false,
      // ConsentVisible: false,
      ConsentChecked: false,
      ConsentAccepted: false,
      ConsentError: '',
      SubmitMessage: "",
      SubmitAttempted: false,

      HistoryVisible: false,
      HistoryLoading: false,
      HistoryData: [],

      HistoryPagination: {
        Page: 1,
        PageSize: 10,
        Total: 0
      },

      HistoryColumns: [
        {
          title: 'STT',
          dataIndex: 'STT',
          key: 'STT',
          width: 45,
          align: 'center'
        },
        {
          title: 'Ngày',
          key: 'Created_At',
          width: 105,
          scopedSlots: {
            customRender: 'HistoryDate'
          }
        },
        {
          title: 'Mã',
          key: 'Scratch_Code',
          width: 80,
          scopedSlots: {
            customRender: 'HistoryCode'
          }
        },
        {
          title: 'Trạng thái',
          key: 'Scratch_Status',
          width: 95,
          align: 'center',
          scopedSlots: {
            customRender: 'HistoryStatus'
          }
        }
      ],
      Poster,
      TutoralVideo,
      RewardCodePlaceholder,
      IdentityPlaceholder,
      CapIcon,
      TabIcon,

      widgetId: null,
      showV2: true,
      v2Token: null, // giữ token V2 khi user tick

      IsNotYet: true,
      nowTime: null,
      IsConfirmAge: false,
      IsUnder18: false,
      IsOver18Confirm: false,
      UserMenu: "",
      isLoadingTBL: false,
      TotalCount: 0,
      IsReset_VerifyPhone: false,

      FullName: "",
      DoB: null,
      Address: "",
      Phone: '',
      PhoneStatus: '',
      PhoneError: '',
      OTPCode: '',
      OTPSent: false,
      OTPVerified: false,
      OTPMessage: '',
      OTPMessageType: 'info',
      OTPTrackingID: '',
      SendingOTP: false,
      VerifyingOTP: false,
      ResendSeconds: 0,
      ResendTimer: null,

      TurnstileID: null,
      TurnstileToken: '',
      SubmittingReward: false,


      ScratchCode: '',
      ScratchCodeStatus: '',
      ScratchCodeError: "",
      isRuleOpen: false,
      isHelpOpen: false,
      lstRuleImage: [],
      lstHelpImage: [],
      ScratchLen: this.$PRJ_SCRATCH_LEN || 12,

      oResponseData: {
        Request_ID: "",
        Scratch_Status: "",
        MT_Message: "Đang kiểm tra kết quả, vui lòng đợi trong giây lát",
        User_ID: '',
      },
      lstMenuData: [
        {
          Type: "CODE",
          Title: "NHẬP MÃ TRÚNG THƯỞNG",
        },
        {
          Type: "REWARD_LOCATION",
          Title: "TRA CỨU KHU VỰC KHUYẾN MÃI",
        },
        {
          Type: "REWARD_LIST",
          Title: "DANH SÁCH TRÚNG GIẢI NHÌ",
        },
        {
          Type: "RESULT",
          Title: "KẾT QUẢ TRA CỨU",
        },
        {
          Type: "RESPONSE",
          Title: "KẾT QUẢ TRÚNG THƯỞNG",
        }
      ],
      oMenuData: { Type: "", Title: "" },
      TBLcolumns: [
        {
          title: "STT",
          dataIndex: "STT",
          key: "STT",
          align: "center",
          scopedSlots: { customRender: "STT" },
          width: 40,
        },
        {
          title: "Thời gian",
          dataIndex: "Request_Time",
          key: "Request_Time",
          align: "center",
          scopedSlots: { customRender: "Request_Time" },
          width: 100,
        },
        {
          title: "Trạng thái",
          dataIndex: "Scratch_Status",
          key: "Scratch_Status",
          align: "center",
          scopedSlots: { customRender: "Scratch_Status" },
          width: 50,
        },
      ],
      currentPage: 1,
      TBLdata: [],
      page: 1,
      // Track selection state to decide replace vs override-next
      isUserSelecting: false,
      selectedIndex: null,
      lastCaretIndex: null,
      lastCaretPos: 1,
    };
  },
  methods: {
    ...mapActions(["API_GetInfo", "API_SearchPhone", "API_PollingOTP", "API_SentMO_CF", "API_SentMO_V2", "API_SendOTP", "API_VerifyOTP", "API_SubmitReward", "API_GetEntryHistory"]),

    handleScratchCodeChange(payload) {
      this.ScratchCodeCells = payload.cells

      if (payload.complete) {
        this.ScratchCodeError = ''
      }
    },

    handleScratchCodeComplete(code) {
      if(this.$IS_DEV)
      console.log('Scratch code:', code)
    },
    // renderRecaptcha() {
    //   if(this.UserMenu=="CODE" ||this.UserMenu=="") {
    //     if (window.grecaptcha && this.$refs.captchaV2) {
    //     this.v2WidgetId = grecaptcha.render(this.$refs.captchaV2, {
    //       sitekey: this.$SITE_KEY_V2,  // khai báo ở main.js
    //       callback: this.onVerifyV2
    //     });
    //   } else {
    //     // console.warn("grecaptcha chưa sẵn sàng, thử lại...");
    //     setTimeout(this.renderRecaptcha, 500); // retry sau 0.5s
    //   }
    //   }
    // },
    NormalizeFullName() {
      const value = String(this.FullName || '')
        .trim()
        .replace(/\s+/g, ' ')
        .toLocaleLowerCase('vi-VN')

      this.FullName = value.replace(
        /(^|\s)(\p{L})/gu,
        (match, space, letter) =>
          space + letter.toLocaleUpperCase('vi-VN')
      )
    },

    FormatFullName(value) {
      return String(value || '')
        .replace(/\s+/g, ' ')
        .toLocaleLowerCase('vi-VN')
        .replace(
          /(^|\s)(\p{L})/gu,
          (match, space, letter) =>
            space + letter.toLocaleUpperCase('vi-VN')
        )
    },

    SubmitMessageText() {
      if (this.SubmittingReward) {
        return 'Hệ thống đang xử lý thông tin của bạn.'
      }

      if (!this.OTPVerified) {
        return 'Vui lòng xác minh số điện thoại trước khi nhận thưởng.'
      }

      if (!this.IsOver18Confirm) {
        return 'Vui lòng xác nhận bạn đã đủ 18 tuổi.'
      }

      if (!this.ConsentAccepted) {
        return 'Vui lòng đồng ý với thể lệ và chính sách chương trình.'
      }

      if (String(this.FullName || '').trim().length < 2) {
        return 'Vui lòng nhập đầy đủ họ và tên.'
      }

      if (!this.DoB) {
        return 'Vui lòng chọn ngày sinh.'
      }
      if (String(this.Address || '').trim().length < 5
      ) {
        return 'Vui lòng nhập địa chỉ.'
      }
      if (
        String(this.ScratchCode || '').length !==
        this.CODE_LENGTH
      ) {
        return `Vui lòng nhập đủ ${this.CODE_LENGTH} ký tự của mã trúng thưởng.`
      }

      if (!this.CodeImage) {
        return 'Vui lòng tải ảnh mã trúng thưởng.'
      }

      if (!this.IdentityImage) {
        return 'Vui lòng tải ảnh CCCD.'
      }

      if (!this.$IS_DEV && !this.TurnstileToken) {
        return 'Vui lòng hoàn tất bước xác minh bảo mật.'
      }

      return ''
    },
    OnFullNameInput(value) {
      this.FullName = this.FormatFullName(value)
    },
    ChangeCodeType() {
      // Khi đổi loại mã, xóa mã cũ để tránh sai độ dài.
      this.ScratchCode = "";
    },
    ResetTurnstile() {
      if(this.$IS_DEV)
      console.log('Entry-ResetCaptcha')

      this.TurnstileToken = ''

      if (
        window.turnstile &&
        this.TurnstileID !== null
      ) {
        window.turnstile.reset(
          this.TurnstileID
        )
      }
    },

    RemoveTurnstile() {
      this.TurnstileToken = ''

      if (
        window.turnstile &&
        this.TurnstileID !== null
      ) {
        try {
          window.turnstile.remove(this.TurnstileID)
        } catch (error) {
      if(this.$IS_DEV)
          console.log('Turnstile-Remove-Error:', error)
        }
      }

      this.TurnstileID = null
    },
    ExtractOTPTrackingID(Result) {
      const Data = Result && Result.Data ? Result.Data : {};

      return String(
        Data.Tracking_ID ||
        Data.tracking_id ||
        (Data.Data && Data.Data.tracking_id) ||
        (Data.Data && Data.Data.data && Data.Data.data.tracking_id) ||
        ""
      ).trim();
    },

    Sleep(Milliseconds) {
      return new Promise((Resolve) => setTimeout(Resolve, Milliseconds));
    },

    GetOTPDeliveryErrorMessage(Result) {
      const Data = Result && Result.Data ? Result.Data : {}
      const ErrorCode = String(
        Data.Error_Code ||
        Data.OTT_Error_Code ||
        Data.ott_error_code ||
        ''
      ).trim()

      switch (ErrorCode) {
        case '108':
          return 'Số điện thoại không hợp lệ. Quý khách vui lòng kiểm tra lại số điện thoại.'

        case '118':
          return 'Số điện thoại này chưa có tài khoản Zalo hoặc tài khoản Zalo đã lâu không hoạt động.'

        case '8':
          return 'Tài khoản Zalo của quý khách đang chặn tin nhắn từ doanh nghiệp. Vui lòng kiểm tra cài đặt Zalo.'

        case '134':
          return 'Tài khoản Zalo hiện chưa cho phép nhận tin nhắn này. Quý khách vui lòng kiểm tra lại Zalo.'

        case '107':
        case '109':
        case '111':
        case '114':
          return 'Hệ thống chưa thể gửi OTP đến Zalo của quý khách. Vui lòng thử lại sau.'

        default:
          return 'Không thể gửi OTP đến Zalo của quý khách. Vui lòng thử lại.'
      }
    },

    async PollOTPDelivery(TrackingID) {
      const StartedAt = Date.now()
      const MaxWait = 30000

      while (Date.now() - StartedAt < MaxWait) {
        await this.Sleep(1000)

        const Result = await this.API_PollingOTP({Tracking_ID: TrackingID,Phone: this.Phone,})
        console.log(Result)
        if (!Result || Number(Result.State) !== 1) {
          // Trạng thái gửi có thể chưa cập nhật kịp, tiếp tục kiểm tra.
          continue
        }

        const Status = String(
          (Result.Data && Result.Data.Status) || Result.Case || ''
        ).toUpperCase()

        if (Status === 'DELIVERED') {
          return {
            State: 1,
            Status: 'DELIVERED',
            Message: 'Mã OTP đã được gửi đến Zalo của quý khách.',
          }
        }

        if (Status === 'FAILED') {
          return {
            State: 0,
            Status: 'FAILED',
            Message: this.GetOTPDeliveryErrorMessage(Result),
          }
        }
      }

      return {
        State: 0,
        Status: 'WAITING_DLR',
        Message: 'OTP đang được gửi đến Zalo của quý khách. Vui lòng kiểm tra Zalo hoặc thử gửi lại sau ít phút.',
      }
    },

    async SendOTP() {
      if (!this.canSendOTP) return

      this.SendingOTP = true
      this.OTPMessage = ''

      const payload = {
        Phone: this.Phone,
        Token: this.TurnstileToken
      }

      if(this.$IS_DEV)
      console.log('OTP-Send: Request', payload)

      try {
        /* THAY BẰNG ACTION HIỆN TẠI CỦA PROJECT */
        const response = await this.API_SendOTP(payload)
      if(this.$IS_DEV)
        console.log('OTP-Send: Response', response)

        const result = response && response.data ? response.data : response

        if (Number(result.State) === 1) {
          if (result.Data.Verified === true || result.Data.OTP_Verified === true) {
            if (result.Data?.Expired_At)
              this.StartSessionCountdown(
                result.Data.Expired_At
              )
            this.MarkOTPVerified(result.Message || 'Đã xác minh số điện thoại thành công.')
          } else if (!this.IsDLREnabled) {
            /*
             * Luồng cũ:
             * API send_otp trả State = 1 là coi như đã gửi.
             * Không cần tracking_id, không poll/chờ DLR.
             */
            this.OTPTrackingID = ''
            this.OTPSent = true
            this.OTPMessageType = 'success'
            this.OTPMessage =
              result.Message ||
              'Mã OTP đã được gửi đến Zalo của quý khách.'
            this.StartResendTimer(
              (result.Data && result.Data.OTP_Resend_After_Seconds) ||
              120
            )
            this.ResetTurnstile()
          } else {
            /*
             * Luồng DLR:
             * SendOTP State=1 là mở ô nhập OTP ngay.
             * Polling chỉ cập nhật Message/MessageType, không khóa ô OTP.
             */
            const TrackingID = this.ExtractOTPTrackingID(result)
            this.OTPTrackingID = TrackingID

            /*
             * Quan trọng:
             * Không chờ DELIVERED mới mở ô OTP.
             */
            this.OTPSent = true
            this.OTPMessageType = TrackingID
              ? 'info'
              : 'warning'
            this.OTPMessage =
              result.Message ||
              (
                TrackingID
                  ? 'Đang chờ xác nhận trạng thái gửi OTP...'
                  : 'OTP đã được yêu cầu gửi nhưng chưa có mã theo dõi trạng thái.'
              )

            this.StartResendTimer(
              (result.Data && result.Data.OTP_Resend_After_Seconds) ||
              120
            )

            this.ResetTurnstile()

            if (TrackingID) {
              /*
               * Không await ở đây:
               * SendOTP kết thúc ngay, ô OTP mở ngay.
               * Poll chạy nền và CHỈ update message.
               */
              this.PollOTPDelivery(TrackingID)
                .then((DLRResult) => {
                  if (!DLRResult) {
                    return
                  }

                  this.OTPMessageType =
                    DLRResult.State === 1
                      ? 'success'
                      : DLRResult.Status === 'FAILED'
                        ? 'error'
                        : 'warning'

                  this.OTPMessage =
                    DLRResult.Message ||
                    this.OTPMessage
                })
                .catch((Error) => {
                  if (this.$IS_DEV) {
                    console.log(
                      'OTP-DLR-POLL-ERROR:',
                      Error
                    )
                  }
                })
            }
          }
        } else {
          this.OTPMessageType = 'error'
          this.OTPMessage = result.Message ||'Không thể gửi OTP đến Zalo của quý khách. Vui lòng thử lại.'
          this.StartResendTimer(60)
          this.ResetTurnstile()
        }
      } catch (error) {
      if(this.$IS_DEV)
        console.log('OTP-Send: Error', error)
        this.OTPMessageType = 'error'
        this.OTPMessage = 'Có lỗi khi gửi OTP đến Zalo của quý khách. Vui lòng thử lại.'
        this.ResetTurnstile()
      }

      this.SendingOTP = false
    },
    ValidateOTP(rawValue) {
      this.OTPCode = String(rawValue || '').replace(/\D/g, '').slice(0, 6)
    },

    async VerifyOTP() {
      if (!this.CanVerifyOTP) return

      this.VerifyingOTP = true
      this.OTPMessage = ''

      const payload = {
        Phone: this.Phone,
        OTP: this.OTPCode
      }

      if(this.$IS_DEV)
      console.log('OTP-Verify: Request', payload)

      try {
        /* THAY BẰNG ACTION HIỆN TẠI CỦA PROJECT */
        const response = await this.$store.dispatch('API_VerifyOTP', payload)
        if(this.$IS_DEV)
          console.log('OTP-Verify: Response', response)

        const result = response && response.data ? response.data : response

        if (Number(result.State) === 1) {
          this.MarkOTPVerified(result.Message || 'Đã xác minh số điện thoại thành công.')
          if (result.Data?.Expired_At)
            this.StartSessionCountdown(
              result.Data.Expired_At
            )
        } else {
          this.OTPMessageType = 'error'
          this.OTPMessage = result.Message || 'Mã OTP không chính xác.'
        }
      } catch (error) {
        if(this.$IS_DEV)
          console.log('OTP-Verify: Error', error)
        this.OTPMessageType = 'error'
        this.OTPMessage = 'Có lỗi khi xác thực OTP. Vui lòng thử lại.'
      }

      this.VerifyingOTP = false
    },

    MarkOTPVerified(message) {
      if(this.$IS_DEV)
        console.log("Vao ham Verified Thanh cong")
      this.OTPVerified = true
      this.OTPSent = true
      this.OTPMessageType = 'success'
      this.OTPMessage = message
      this.StopResendTimer()

      /* Theo luồng đã thống nhất: OTP thành công thì reset Turnstile OTP. */
      this.ResetTurnstile()
    },

    StartResendTimer(seconds) {
      this.StopResendTimer()
      this.ResendSeconds = seconds

      this.ResendTimer = window.setInterval(() => {
        if (this.ResendSeconds <= 1) {
          this.StopResendTimer()
          return
        }

        this.ResendSeconds -= 1
      }, 1000)
    },

    StopResendTimer() {
      if (this.ResendTimer) {
        window.clearInterval(this.ResendTimer)
        this.ResendTimer = null
      }

      this.ResendSeconds = 0
    },

    async SubmitReward() {

      this.SubmitAttempted = true
      if (!this.CanSubmitReward) {
        this.SubmitMessage = this.SubmitMessageText();
        return
      }

      this.SubmittingReward = true
      this.SubmitMessage = ''

      const formData = new FormData()
      formData.append('Phone', this.Phone)
      formData.append('FullName', this.FullName.trim())
      formData.append('DoB', this.DoB)
      formData.append('Address',this.Address.trim())
      formData.append('ScratchCode', this.ScratchCode)
      formData.append('Scratch_Code_Image', this.CodeImage)
      formData.append('CCCD_Image', this.IdentityImage)
      formData.append('Token', this.TurnstileToken)
      /*
       * Không log trực tiếp formData.
       * Phải duyệt entries.
       */
      // for (const [key, value] of formData.entries()) {
      //   console.log(
      //     'FormData:',
      //     key,
      //     value instanceof File
      //       ? {
      //         name: value.name,
      //         type: value.type,
      //         size: value.size
      //       }
      //       : value
      //   )
      // }

      // console.log('Turnstile token:', this.TurnstileToken)

      try {
        /* THAY BẰNG ACTION HIỆN TẠI CỦA PROJECT */
        const response = await this.API_SubmitReward(formData)
      if(this.$IS_DEV)
        console.log('Reward-Submit: Response', response)

        const result = response && response.data ? response.data : response

        if (response && "State" in response) {
          // console.log("PROCESS OK")
          // console.log(result)
          this.processResponseData(result)
        }
        else {
          // console.log("PROCESS null")
          this.processResponseData(null)
        }
        // if (Number(result.State) === 1) {
        //   /* GIỮ NGUYÊN HÀM QUERY SANG RESULT ĐANG CÓ CỦA BẠN. */
        //   this.processResponseData(result)
        // } else {
        //   this.SubmitMessageType = 'error'
        //   this.SubmitMessage = result.Message || 'Không thể ghi nhận mã dự thưởng.'
        //   this.ResetTurnstile()
        // }
      } catch (error) {
        // console.log("process error")
        if(this.$IS_DEV)
          console.log('Reward-Submit: Error', error)
        this.processResponseData(null)
        // this.SubmitMessageType = 'error'
        // this.SubmitMessage = 'Có lỗi khi gửi thông tin. Vui lòng thử lại.'
        // this.ResetTurnstile()
      }

      this.SubmittingReward = false
    },

    DisableBirthday(current) {
      if (!current) return false

      // Chỉ cho phép ngày sinh từ đúng 18 tuổi trở lên.
      const MaxBirthday = this.$moment().subtract(18, 'years')

      return current.isAfter(MaxBirthday, 'day')
    },
    OpenConsent() {
      this.IsShowConsent = true;
      this.ConsentChecked = false
      this.ConsentError = ''
      // this.ConsentVisible = true
    },

    OpenConsentAfterPosterLoaded() {
      if (!this.ConsentAccepted) this.OpenConsent()
    },

    AcceptConsent() {
      if (!this.ConsentChecked) {
        this.ConsentError = 'Vui lòng xác nhận đồng ý trước khi tiếp tục.'
        return
      }

      this.ConsentAccepted = true
      this.ConsentError = ''
      this.IsShowConsent = false;
      // this.ConsentVisible = false

      this.$nextTick(() => {
        this.RenderTurnstile()
      })
    },
    // RenderTurnstile() {
    //   if (this.UserMenu == "CODE" || this.UserMenu == "") {
    //     if (window.turnstile && this.$refs.captcha) {
    //       window.turnstile.render(this.$refs.captcha, {
    //         sitekey: '0x4AAAAAACyeuhyTZG5Q7gaL',
    //         callback: (token) => {
    //           this.v2Token = token
    //         }
    //       })
    //     } else {
    //       // console.warn("grecaptcha chưa sẵn sàng, thử lại...");
    //       setTimeout(this.RenderTurnstile, 500); // retry sau 0.5s
    //     }
    //   }


    // },
    StartSessionCountdown(expiredAt) {
      this.StopSessionCountdown()

      this.SessionExpiredAt = expiredAt
      this.UpdateSessionCountdown()

      this.CountdownTimer = setInterval(() => {
        this.UpdateSessionCountdown()
      }, 1000)
    },

    UpdateSessionCountdown() {
      const expiredTime = new Date(
        this.SessionExpiredAt
      ).getTime()

      if (!Number.isFinite(expiredTime)) {
        this.CountdownSeconds = 0
        return
      }

      const remaining = Math.ceil(
        (expiredTime - Date.now()) / 1000
      )

      this.CountdownSeconds = Math.max(
        remaining,
        0
      )

      if (remaining <= 0) {
        this.HandleSessionExpired()
      }
    },

    StopSessionCountdown() {
      if (this.CountdownTimer) {
        clearInterval(this.CountdownTimer)
        this.CountdownTimer = null
      }
    },

    HandleSessionExpired() {
      this.StopSessionCountdown()

      if (this.SessionExpired) {
        return
      }

      this.SessionExpired = true
      this.TURNSTILE_TOKEN = ''

      // this.$message.warning(
      //   'Phiên xác minh đã hết hạn. Vui lòng xác minh lại số điện thoại.'
      // )
      this.OTPVerified = false;
      this.OTPSent = false;
      this.OTPCode = "";
      this.CODE_TYPE = ""
      this.ScratchCode = ""
      this.SessionExpiredAt = null
      this.CountdownSeconds = 0
      this.CodeImage = null;
      this.IdentityImage = null;
      this.OTPMessage = "Phiên hết hạn. Vui lòng xác minh lại số điện thoại."
      this.OTPMessageType = "warning"
      // this.RemoveTurnstile()
      // this.MENU = 'PHONE'
      this.RemoveTurnstile()

      this.$nextTick(() => {
        this.RenderTurnstile()
      })
    },
    RenderTurnstile() {
      if(this.$IS_DEV) return;
      if (
        this.UserMenu !== 'CODE' &&
        this.UserMenu !== ''
      ) {
        return
      }

      /*
       * Đã render rồi thì không render lại.
       */
      if (this.TurnstileID !== null) {
        return
      }

      if (
        !window.turnstile ||
        !this.$refs.captcha
      ) {
        setTimeout(
          () => this.RenderTurnstile(),
          500
        )

        return
      }

      this.TurnstileID = window.turnstile.render(
        this.$refs.captcha,
        {
          sitekey: '0x4AAAAAACyeuhyTZG5Q7gaL',

          callback: token => {

            this.TurnstileToken = token
          },

          'expired-callback': () => {

            this.TurnstileToken = ''
          },

          'error-callback': () => {

            this.TurnstileToken = ''
          }
        }
      )
    },
    onCaptchaSuccess(token) {
      this.v2Token = token
    },
    OpenHistoryModal() {
      this.HistoryVisible = true
      this.HistoryPagination.Page = 1
      this.LoadHistory()
    },

    HistoryPageChange(page) {
      this.HistoryPagination.Page = page
      this.LoadHistory()
    },

    async LoadHistory() {
      if (this.HistoryLoading) {
        return
      }

      this.HistoryLoading = true

      try {
        const response = await this.API_GetEntryHistory(
          {
            Session_ID: this.Session_ID,
            Phone: this.Phone,
            Page: this.HistoryPagination.Page,
            PageSize: this.HistoryPagination.PageSize
          }
        )


        if (!response || response.State !== 1) {
          this.HistoryData = []
          this.HistoryPagination.Total = 0

          this.$message.error(
            response && response.Message
              ? response.Message
              : 'Không tải được lịch sử.'
          )

          return
        }

        this.FillHistoryData(response.Data)
      } catch (error) {
        console.error('History-Load-Error:', error)

        this.HistoryData = []
        this.HistoryPagination.Total = 0
      } finally {
        this.HistoryLoading = false
      }
    },

    FillHistoryData(data) {
      const items =
        data && Array.isArray(data.Items)
          ? data.Items
          : []

      this.HistoryData = items.map(
        (item, index) => ({
          ...item,

          STT:
            (this.HistoryPagination.Page - 1) *
            this.HistoryPagination.PageSize +
            index +
            1
        })
      )

      this.HistoryPagination.Total =
        Number(data && data.Total) || 0
    },

    FormatDate(value) {
      const date = moment(value)

      return date.isValid()
        ? date.format('DD/MM/YYYY')
        : '--/--/----'
    },

    FormatTime(value) {
      const date = moment(value)

      return date.isValid()
        ? date.format('HH:mm:ss')
        : '--:--:--'
    },

    MaskScratchCode(value) {
      const code = String(value || '')
        .trim()
        .toUpperCase()

      if (!code) {
        return '---'
      }

      return (
        '*'.repeat(
          Math.max(code.length - 3, 0)
        ) +
        code.slice(-3)
      )
    },

    GetStatus(record) {
      const status = String(
        record.Scratch_Status || ''
      ).toUpperCase()

      const map = {
        SUCCESS: {
          Text: 'Thành công',
          Color: 'green'
        },

        WRONG: {
          Text: 'Không đúng',
          Color: 'red'
        },

        DUPLICATE: {
          Text: 'Đã dùng',
          Color: 'orange'
        },

        EXPIRED: {
          Text: 'Hết hạn',
          Color: 'default'
        }
      }

      return map[status] || {
        Text: 'Chưa rõ',
        Color: 'default'
      }
    },
    // async processScratch() {
    //   this.isLoadingTBL = true;
    //   let oResponse = null
    //   let oMO = {
    //     checksum: "43c20d08987ce2cbfa761a37e876e2c6",
    //     shortcode: this.$PRJ_SMSGW,
    //     phone: this.Phone,
    //     sms: this.textToHex(this.ScratchCode),
    //     time: moment().unix(),
    //     id: ""
    //   }
    //   if (process.env.NODE_ENV === 'development')
    //     console.log(oMO)

    //   if (this.showV2) {

    //     oMO.token = this.v2Token;
    //     // Nếu đang ở chế độ V2 thì check token
    //     // if (!this.v2Token) {
    //     //   alert("⚠️ Vui lòng xác minh reCAPTCHA V2 trước khi submit")
    //     //   return
    //     // }
    //     oResponse = await this.API_SentMO_CF(oMO)
    //     if (process.env.NODE_ENV === 'development')
    //       console.log(oResponse)
    //     if (oResponse && "State" in oResponse) {
    //       this.processResponseData(oResponse)
    //     }
    //     else {
    //       this.processResponseData(null)
    //     }
    //   }

    //   // Nếu chưa bật V2 thì chạy V3
    //   // await grecaptcha.ready(async () => {
    //   //   await grecaptcha.execute(this.$SITE_KEY_V3, { action: 'login' })
    //   //     .then(async (token) => {
    //   //       oMO.token = token
    //   //       oMO.action = 'login'
    //   //       oResponse = await this.API_SentMO_V3(oMO)
    //   //       if (process.env.NODE_ENV === 'development')
    //   //         console.log(oResponse)
    //   //       if (oResponse && ("State" in oResponse)) {
    //   //         this.processResponseData(oResponse)
    //   //       } else if (oResponse && ("ok" in oResponse)) {

    //   //         this.isLoadingTBL = false;
    //   //         // Nếu V3 score thấp → show V2
    //   //         this.showV2 = true
    //   //         this.$nextTick(() => {
    //   //           grecaptcha.render(document.querySelector('.g-recaptcha'), {
    //   //             sitekey: this.$SITE_KEY_V2,
    //   //             callback: this.onVerifyV2
    //   //           })
    //   //         })
    //   //       }
    //   //       else {
    //   //         this.processResponseData(null)
    //   //       }
    //   //     })
    //   // })
    //   // console.log(oMO)
    //   // sessionStorage.setItem('RESULT',JSON.stringify(oMO))
    // },
    processResponseData(oResponse) {
      // let oResponse = await this.API_SentMO(oMO)
      if(this.$IS_DEV)
        console.log(oResponse)

      if (oResponse) {
        // if (!("State" in oResponse) || oResponse.State == 0) {
        //   oResponse.MT_Message = oResponse.Message
        //   oResponse.Request_ID = ""
        //   oResponse.Scratch_Status = "Wrong"
        // }
        oResponse.VIEW_TIME = 1;
        oResponse.Message = ""
        oResponse.Scratch_Status = oResponse.Data.Scratch_Status
        // "Data": 
        oResponse.Data.User_ID = this.Phone
        if (oResponse.Data?.Reset_Verification)
          this.IsReset_VerifyPhone = oResponse.Data.Reset_Verification
        oResponse.IsReset_VerifyPhone = this.IsReset_VerifyPhone;
        sessionStorage.setItem('RESPONSE', JSON.stringify(oResponse))
        //=========================================

        // sessionStorage.setItem('RESPONSE', JSON.stringify({
        //   "State": 1,
        //   "Message":
        //   "Data": {
        //     "Request_ID": "9903255162",
        //     "Scratch_Status": "Success",
        //     "MT_Message": "Mã số <ma the cao> hợp lệ. Chúc mừng quý khách trúng thưởng <so tien> đồng tiền nạp điện thoại từ BIASG. Mã thẻ cào VIETTEL của bạn là 125125125215"
        //   }
        // }))
      }
      else {
        sessionStorage.setItem('RESPONSE', JSON.stringify({
          "State": 1,
          "Message": "",
          "Data": {
            "Request_ID": "",
            "Scratch_Status": "Error",
            "MT_Message": "Có lỗi xảy ra, Vui lòng thử lại."
          }
        }))
      }
      this.StopSessionCountdown()
      this.RemoveTurnstile()
      this.goPage("RESPONSE")
    },
    goPage(UserMenu) {
      if (UserMenu == "")
        window.location.href = "/"
      else
        window.location.href = "/?Page=" + UserMenu
    },
    async onSearchPhone() {
      this.isLoadingTBL = true;
      try {
        if (this.Phone.length == 10) {
          if (this.$refs.cap.check()) {
            // this.$refs.cap.generate();
            this.CaptchaValue = ""
            let oResponse = await this.API_SearchPhone(this.Phone)

      if(this.$IS_DEV)
              console.log(oResponse)
            if (oResponse) {
              oResponse.VIEW_TIME = 2;
              sessionStorage.setItem('RESULT', JSON.stringify(oResponse))
              this.goPage("RESULT")
            }
          }
          else {
            //
          }
        }
      } catch (error) {
      if(this.$IS_DEV)
        console.log(error.message)
      }
      this.isLoadingTBL = false;
    },

    onBack2Code() {
      this.goPage('CODE');
      sessionStorage.setItem("IsResponse2Code", "true")
    },
    onclick() {
      new FlipDown(Math.floor(Date.now() / 1000) + 86400) // +1 ngày
        .start()
        .ifEnded(() => {
          /**/
        })
    },
    validatePhone(raw) {
      try {
        const incoming = typeof raw === 'string' ? raw : '';
        const digitsOnly = incoming.replace(/\D/g, '').slice(0, 10);
        if (this.Phone !== digitsOnly) {
          this.Phone = digitsOnly;
        }
        if (digitsOnly.length === 0) {
          this.PhoneError = '';
          this.PhoneStatus = '';
          return false;
        }
        if (!/^0\d{9}$/.test(digitsOnly)) {
          this.PhoneError = 'SĐT phải gồm 10 số và bắt đầu bằng 0';
          this.PhoneStatus = 'error';
          return false;
        }
        this.PhoneError = '';
        this.PhoneStatus = 'success';
        return true;
      } catch (error) {
        this.PhoneError = 'Số điện thoại không hợp lệ';
        this.PhoneStatus = 'error';
        return false;
      }
    },
    textToHex(str) {
      return Array.from(str)
        .map(char => char.charCodeAt(0).toString(16).padStart(2, '0'))
        .join('')
        .toUpperCase();
    },
    async SelectMenu(sMenu) {
      try {
        this.isLoadingTBL = true;
        this.IsOver18Confirm = true
        this.UserMenu = sMenu
        this.searchText = ""
        this.oMenuData = this.lstMenuData.find(st => st.Type == sMenu)
        if (sMenu == 'CODE') {
          sessionStorage.removeItem("RESULT")
          sessionStorage.removeItem("RESPONSE")
          let oSessionData = sessionStorage.getItem("IsResponse2Code")
          if (!oSessionData) {
            this.goPage("")
          }
          else {
            this.$nextTick(() => {
              this.RenderTurnstile()
            })
            this.ConsentAccepted = true;
            sessionStorage.removeItem("IsResponse2Code")
          }
        }
        if (sMenu == "RESULT") {
          let oSessionData = sessionStorage.getItem("RESULT")
          if (!oSessionData) {
            window.location.href = "/"
          }
          oSessionData = JSON.parse(oSessionData)

      if(this.$IS_DEV)
            console.log(oSessionData)
          if ("VIEW_TIME" in oSessionData)
            oSessionData.VIEW_TIME--
          else oSessionData.VIEW_TIME = 0

          sessionStorage.setItem("RESULT", JSON.stringify(oSessionData))
          if (!oSessionData.VIEW_TIME || oSessionData.VIEW_TIME == 0) {
            sessionStorage.removeItem("RESULT")
          }
          if (oSessionData.State == 1) {
            this.lstData = oSessionData.Message
            this.lstData.filter(st => st.STT = this.lstData.indexOf(st) + 1)
            this.TotalCount = oSessionData.Message.length
            await this.fillData()
          }
        }
        if (sMenu == "RESPONSE") {
          let oSessionData = sessionStorage.getItem("RESPONSE")
          if (!oSessionData) {
            window.location.href = "/"
          }
          oSessionData = JSON.parse(oSessionData)
          if ("VIEW_TIME" in oSessionData)
            oSessionData.VIEW_TIME--
          else oSessionData.VIEW_TIME = 0

          sessionStorage.setItem("RESPONSE", JSON.stringify(oSessionData))
          if (!oSessionData.VIEW_TIME || oSessionData.VIEW_TIME == 0) {
            sessionStorage.removeItem("RESPONSE")
          }
          if (sessionStorage?.IsReset_VerifyPhone)
            this.IsReset_VerifyPhone = sessionStorage.IsReset_VerifyPhone
      if(this.$IS_DEV)
            console.log(oSessionData)
          await this.sleepRandom()
          if (oSessionData.State == 0) {
            this.oResponseData.Scratch_Status = oSessionData.Data.Scratch_Status || "Wrong"
            this.oResponseData.MT_Message = oSessionData.Data.MT_Message.toString().replace("Liên hệ", "<br/>Liên hệ");
          }
          else {
            this.oResponseData.MT_Message = oSessionData.Data.MT_Message.toString().replace("Liên hệ", "<br/>Liên hệ");
            this.oResponseData.Request_ID = oSessionData.Data.Request_ID
            this.oResponseData.Scratch_Status = oSessionData.Data.Scratch_Status
            // this.oResponseData.User_ID = oSessionData.Message.User_ID
          }
      if(this.$IS_DEV)
            console.log(this.oResponseData)
        }
      } catch (error) {
      if(this.$IS_DEV)
        console.log(error.message)
      }
      this.isLoadingTBL = false;
    },
    onChangePage(page) {
      try {
        // console.log(this.lstData)
        this.isLoadingTBL = true;
        this.currentPage = page
        this.TBLdata = this.lstData.slice((this.currentPage - 1) * 10, (this.currentPage - 1) * 10 + 10);
        this.isLoadingTBL = false;
      } catch (error) {
        //
      }
    },
    async fillData(page = 1) {
      this.onChangePage(page)
    },
    async sleepRandom() {
      const ms = Math.floor(Math.random() * 4000) + 1000;
      return new Promise(resolve => setTimeout(resolve, ms));
    },

    onVerifyV2(token) {
      // chỉ lưu token, chưa gửi server
      this.v2Token = token

      if(this.$IS_DEV)
        console.log("V2 Token:", token)
    }
  }
}
</script>
<style>
body {
  height: 100% !important;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
  font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;

  min-height: 100% !important;
  width: 100%;
  overflow: hidden;
  background: url('~@/assets/bg.png') bottom center;
  background-size: cover;
}

.bg-absolute {
  position: fixed;
  bottom: 0;
  left: 70px;
  right: 0;
  /* width: 650px; */
  height: 81vh;
}

.bg-logo {
  position: absolute;
  top: 0;
  left: 0;
  /* width: 90%; */
  max-width: 600px;
  /* width: 700px; */
  /* margin-top: -40px !important; */
}

.bg-center {
  z-index: -1;
  /* margin-top: -30px;
  width: 700px; */
  position: absolute;
  top: 0;
  left: 0;
  width: auto;
  max-width: 800px;
  max-height: 100vh;
}

.login {
  position: relative;
  width: 80%;
  max-width: 100%;
  padding: 160px 35px 0;
  margin: 0 auto;
  overflow: hidden;
}

form.form-code {
  padding: 2px;
}

form.form-code .ant-col {
  padding: 2px;
  padding-bottom: 0px;
  padding-top: 1px;
}

form.form-code .ant-form-item {
  margin-bottom: 0px !important;
}

.form-code ::v-deep .ant-form-item {
  margin-bottom: 5px;
}

.fish.input {
  padding-bottom: 10px !important;
}

.fish.input>i {
  top: -5px !important;
}

.fish.layout {
  height: 100% !important;
}

.menu_button {
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.3), -2px -2px 5px rgba(255, 255, 255, 0.3) !important;
  height: 100% !important;
  font-size: 12px !important;
  font-weight: bold !important;
  /* font-weight: 600 !important; */
  text-transform: uppercase;
  line-height: 26px !important;
  border: 2px solid #00507a !important;
  color: #00507a !important;
  padding: 0px 5px !important;
  min-width: 70px;
  transition: all 0.4s !important;
}

.menu_button:hover,
.menu_button.active {
  border: 2px solid white !important;
  color: white !important;
  background-color: #00507a !important;
}

.confirmage_button {
  height: 100% !important;
  font-size: 1.125rem !important;
  font-weight: 600 !important;
  text-transform: uppercase;
  line-height: 40px !important;
  border: 2px solid #00507a !important;
  color: #00507a !important;
  padding: 0px 20px !important;
  min-width: 170px;
  transition: all 0.4s !important;
}

.confirmage_button:hover {
  color: white !important;
  background-color: #00507a !important;
  /*A81E22 red export */
  border: 2px solid white !important;
}

.agreetext {
  color: cornsilk;
  font-weight: 700;
  text-shadow: 0 2px 2px rgba(0, 0, 0, 0.9), 0 3px 5px rgba(0, 0, 0, 0.55);
  padding: 0 10px;
}

.sbc-button {
  font-weight: bold !important;
  color: white !important;
  width: 100%;
  background: #00507a !important;
}

/* Disabled state for action button */
.ant-btn.sbc-button[disabled],
.ant-btn.sbc-button[disabled]:hover,
.sbc-button[disabled],
.sbc-button[disabled]:hover,
.ant-btn-disabled.sbc-button,
.ant-btn-disabled.sbc-button:hover {
  background: #bfbfbf !important;
  /* gray */
  border-color: #bfbfbf !important;
  color: #ffffff !important;
  cursor: not-allowed !important;
  opacity: 1 !important;
}

.sbc-smallbutton {
  height: 20px;
}

.sbc-medbutton {
  height: 20px;
}

.sbc-bigbutton {
  height: 40px !important;
}

/* .row{
    margin-left: unset!important;
    margin-right: unset!important;
} */

.popup-dialog {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: 9999;
  filter: alpha(opacity=0);
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";
  -webkit-opacity: 0;
  -khtml-opacity: 0;
  -moz-opacity: 0;
  -ms-opacity: 0;
  -o-opacity: 0;
  opacity: 0;
  background: rgba(0, 0, 0, 0.8);
  -webkit-transition: opacity 400ms ease-in;
  -khtml-transition: opacity 400ms ease-in;
  -moz-transition: opacity 400ms ease-in;
  -ms-transition: opacity 400ms ease-in;
  -o-transition: opacity 400ms ease-in;
  transition: opacity 400ms ease-in;
  pointer-events: none;
}

.popup-dialog:target,
.popup-dialog.open {
  filter: alpha(opacity=100);
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=100)";
  -webkit-opacity: 1;
  -khtml-opacity: 1;
  -moz-opacity: 1;
  -ms-opacity: 1;
  -o-opacity: 1;
  opacity: 1;
  pointer-events: auto;
}

.right_panel {
  /* padding: 50px; */
  font-weight: bold;
}


@media (min-width: 769px) {
  .popup-dialog .popup-global {
    margin: 15% auto !important;
  }

  .right_card {
    top: unset;
    position: unset;
  }
}

@media (max-width:768px) {
  .right_card {
    margin-top: 200px;
    position: absolute !important;
    /* padding-top: 30px !important;
    padding: 5px; */
  }

  .bg-center {
    /* padding-top: 10px; */
    padding-bottom: 10px;
    width: 100%;
  }

  .bg-absolute {
    width: 100%;
    left: 0;
    padding-top: 20px;
    height: unset !important;
  }


  .bg-logo {
    width: 90%;
    /* margin-top: -20px !important; */
    padding-bottom: 15px;
  }
}

.fish.card {
  padding: 10px !important;
}

.fish.card>.header {
  color: #00507a;
  /* color: #BB2125; */
  font-weight: bold;
  font-size: 20px;
  padding: 10px 0 !important;
}

.fish.card>.footer {
  padding: 5px 7px !important;
}

.fish.card.fliptime>.content {
  padding-bottom: 10px !important;
  display: flex;
  justify-content: center;
  height: 100%;
}

.flipdown {
  height: unset !important;
}

.popup-dialog .popup-global {
  margin: 50% 15px;
  position: relative;
  max-width: 600px;
  padding: 30px 40px;
  background: #dea81d;
}

.popup-dialog .close {
  font-size: 0.9375rem;
  font-weight: 500;
  color: #fff;
  width: 35px;
  height: 35px;
  line-height: 35px;
  text-align: center;
  filter: alpha(opacity=100);
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=100)";
  -webkit-opacity: 1;
  -khtml-opacity: 1;
  -moz-opacity: 1;
  -ms-opacity: 1;
  -o-opacity: 1;
  opacity: 1;
  border-radius: 50%;
  position: absolute;
  top: -10px;
  right: -10px;
  background-color: #b30d14;
}

.popup-dialog .close:hover {
  filter: alpha(opacity=100);
  background-color: #77070d;
}

.popup-dialog .popup-global .popup--content {
  /* font-size: 1rem; */
  color: #fff;
  /* font-weight: 700; */
  line-height: 1.5;
  text-align: center;
}

.searchBox {
  width: 250px !important;
  margin-bottom: 5px !important;
}

.text-black {
  color: black !important;
}

.text-khaki {
  color: khaki !important;
}

.text-floralwhite {
  color: floralwhite !important;
}

.text-white {
  color: white !important;
}

.text-left {
  text-align: left !important;
}

.text-right {
  text-align: right !important;
}

.text-non-shadow {
  text-shadow: 0 0 black !important;
}

html {
  overflow-y: overlay !important;

}

.age-warning {
  color: #ff4d4f;
  font-weight: bold;
  padding: 8px 0;
}

/* Make labels closer to inputs and increase input font size */
.ant-form-item-label>label {
  line-height: 22px;
}

.ant-form-item {
  margin-bottom: 14px !important;
}

.ant-input,
.ant-select-selection__rendered,
.ant-input-number-input {
  font-size: 16px !important;
  /* default ~14px, +2 */
}

.ant-select-selection {
  font-size: 16px !important;
}

.ant-radio-wrapper {
  color: black !important;
  font-size: 14px !important;
}

.image-list {
  display: flex;
  flex-direction: column;
  /* từng ảnh xuống dòng */
}

.image-item {
  width: 100%;
}

.image-item img {
  width: 100%;
  max-width: 1000px;
  height: auto;
  display: block;
}

.modalRule {
  padding-top: 50px
}

.ant-modal-title {
  font-size: 22px !important;
  text-align: center;
}


.consent-modal .ant-modal {
  width: calc(100% - 24px) !important;
  max-width: 680px;
}

.consent-modal .ant-modal-content {
  overflow: hidden;
  border-radius: 10px;
}

.consent-box {
  color: #262626;
  background: #ffffff;
  font-family: inherit;
}

.consent-box h1,
.consent-box h2,
.consent-box h3,
.consent-box h4,
.consent-box h5,
.consent-box h6 {
  font-family: inherit !important;
}


.consent-box__header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 18px;
  color: #ffffff;
  background: #14532d;
}

.consent-box__header>.anticon {
  flex: 0 0 auto;
  font-size: 24px;
}

.consent-box__header h3 {
  margin: 0;
  color: #ffffff;
  font-size: 18px;
  line-height: 1.35;
  font-weight: 700;
}

.consent-box__header p {
  margin: 3px 0 0;
  color: rgba(255, 255, 255, 0.85);
  font-size: 13px;
  line-height: 1.4;
}

.consent-box__content {
  max-height: 48vh;
  overflow-y: auto;
  padding: 16px 20px;
  color: #434343;
  font-size: 14px;
  line-height: 1.6;
}

.consent-box__content h4 {
  margin: 12px 0 4px;
  color: #14532d;
  font-size: 14px;
  line-height: 1.45;
  font-weight: 700;
}

.consent-box__content h4:first-child {
  margin-top: 0;
}

.consent-box__content p {
  margin: 0;
}

.consent-box__footer {
  padding: 14px 18px 18px;
  border-top: 1px solid #e8e8e8;
  background: #fafafa;
}

.consent-box__footer .ant-checkbox-wrapper {
  color: #262626;
  font-size: 14px;
  line-height: 1.5;
}

.consent-continue {
  height: 42px;
  margin-top: 12px;
  font-weight: 700;
}

.form-alert.ant-alert {
  padding: 0 !important;
}

.form-alert .ant-alert-icon {
  top: 4px !important;
  left: 5px !important;
}

.form-alert .ant-alert-icon {
  position:unset!important;
  margin-right:5px;
}

.field-error {
  margin-top: 6px;
  color: #f5222d;
  font-size: 12px;
}

.SBC_Promotion_name {
  font-family: math;
  color: #fff;
  margin-top: 5px;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.4;
  text-align: center;
  text-transform: uppercase;
  letter-spacing: 1px;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.25);
}

.field-help {
  color: brown;
  margin-top: 5px;
  font-size: 12.4px;
  line-height: 1.45;
}

.confirmAge-title {
  font-family: 'FontAwesome';
  font-weight: 700;
  text-shadow: 0 2px 2px rgba(0, 0, 0, 0.9), 0 3px 5px rgba(0, 0, 0, 0.55);
  font-weight: bold;
  color: khaki;
  font-size: 19px !important;
}

.form-code .code-type-radio {
  display: flex;
  width: 100%;
  gap: 10px;
}

.form-code .code-type-radio .ant-radio-button-wrapper {
  display: flex;
  flex: 1;
  min-width: 0;
  height: 56px;
  padding: 7px 10px;
  align-items: center;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  line-height: normal;
  white-space: normal;
}

.form-code .code-type-radio .ant-radio-button-wrapper>span:last-child {
  display: flex;
  width: 100%;
  min-width: 0;
  align-items: center;
}

.form-code .code-type-radio .ant-radio-button-wrapper::before {
  display: none;
}

.form-code .code-type-radio .ant-radio-button-wrapper div {
  width: 100%
}

.code-type-radio__content {
  display: flex;
  width: 100%;
  min-width: 0;
  align-items: center;
  flex-direction: row !important;
  gap: 8px;
}

.code-type-radio__image {
  display: block;
  flex: 0 0 40px;
  width: 40px;
  height: 40px;
  margin: 0;
  object-fit: contain;
}

.code-type-radio__text {
  display: flex;
  min-width: 0;
  flex: 1;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
}

.code-type-radio__title,
.code-type-radio__note {
  display: block;
  width: 100%;
  margin: 0;
  overflow: hidden;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.code-type-radio__title {
  font-size: 13px;
  font-weight: 600;
}

.code-type-radio__note {
  margin-top: 2px;
  color: rgba(0, 0, 0, 0.45);
  font-size: 10px;
  font-weight: 400;
}

.form-code .code-type-radio .ant-radio-button-wrapper-checked {
  position: relative;
  z-index: 2;
  border: 1px solid #1890ff !important;
  background: #e6f7ff !important;
  color: #1890ff !important;
  box-shadow: none !important;
}

.form-code .code-type-radio .ant-radio-button-wrapper-checked .code-type-radio__title,
.form-code .code-type-radio .ant-radio-button-wrapper-checked .code-type-radio__note {
  color: #1890ff !important;
}

.turnstile-wrap {
  display: flex;
  width: 100%;
  height: 58px;
  justify-content: center;
  overflow: hidden;
}

.turnstile-wrap>div {
  width: 300px;
  transform: scale(0.82);
  transform-origin: top center;
}

.form-code .code-type-radio--attention .ant-radio-button-wrapper {
  /* border-color: #ff4d4f !important; */
  background: #fff2f0;
  animation: code-type-attention 1.8s ease-in-out infinite;
}

.form-code .code-type-radio--attention .ant-radio-button-wrapper:nth-child(2) {
  animation-delay: 0.15s;
}

@keyframes code-type-attention {

  0%,
  100% {
    border-color: rgba(255, 77, 79, 0.45);
    box-shadow: 0 0 0 0 rgba(255, 77, 79, 0);
  }

  50% {
    border-color: #ff4d4f;
    box-shadow: 0 0 0 3px rgba(255, 77, 79, 0.12);
  }
}

.award-divider {
  display: flex;
  width: 100%;
  margin: 10px 0 0;
  align-items: center;
  gap: 9px;
  color: rgba(0, 0, 0, 0.65);
  white-space: nowrap;
  overflow-x: hidden;
}

.award-divider::before {
  margin-left: -12px;
  content: '';
  height: 1px;
  background: #e8e8e8;
}

.award-divider::after {
  content: '';
  height: 1px;
  background: #e8e8e8;
}

.award-divider::before {
  flex: 0 0 5%;
  min-width: 16px;
  max-width: 38px;
}

.award-divider::after {
  min-width: 16px;
  flex: 1;
}

.award-divider__title {
  flex: 0 0 auto;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-weight: 600;
}

.award-divider__countdown {
  display: inline-flex;
  height: 24px;
  padding: 4px 9px;
  align-items: center;
  gap: 5px;
  border: 1px solid #91d5ff;
  border-radius: 999px;
  background: #f0faff;
  color: #096dd9;
  font-size: 12px;
  line-height: 1;
}

.award-divider__countdown strong {
  font-size: 13px;
  letter-spacing: 0.4px;
  font-variant-numeric: tabular-nums;
}

.award-divider__countdown--warning {
  border-color: #ff7875;
  background: #fff1f0;
  color: #cf1322;
}

.countdown-alarm-icon {
  display: block;
  width: 18px;
  height: 18px;
  object-fit: contain;
  transform-origin: 50% 80%;
  animation: alarm-shake-strong 1.4s ease-in-out infinite;
}

@keyframes alarm-shake-strong {

  0%,
  55%,
  100% {
    transform: rotate(0deg) scale(1);
  }

  60% {
    transform: rotate(-22deg) scale(1.08);
  }

  65% {
    transform: rotate(20deg) scale(1.08);
  }

  70% {
    transform: rotate(-18deg) scale(1.06);
  }

  75% {
    transform: rotate(16deg) scale(1.06);
  }

  80% {
    transform: rotate(-12deg) scale(1.04);
  }

  85% {
    transform: rotate(10deg) scale(1.04);
  }

  90% {
    transform: rotate(-6deg) scale(1.02);
  }

  95% {
    transform: rotate(4deg) scale(1.01);
  }
}

.countdown-alarm-icon--urgent {
  transform-origin: 50% 80%;
  animation: alarm-shake-continuous 0.35s ease-in-out infinite;
}

@keyframes alarm-shake-continuous {
  0% {
    transform: rotate(-22deg) scale(1.08);
  }

  14% {
    transform: rotate(20deg) scale(1.08);
  }

  28% {
    transform: rotate(-18deg) scale(1.06);
  }

  42% {
    transform: rotate(16deg) scale(1.06);
  }

  56% {
    transform: rotate(-12deg) scale(1.04);
  }

  70% {
    transform: rotate(10deg) scale(1.04);
  }

  84% {
    transform: rotate(-6deg) scale(1.02);
  }

  100% {
    transform: rotate(4deg) scale(1.01);
  }
}

.history-pagination {
  padding: 10px 12px 10px;
  display: flex;
  justify-content: flex-end;
}

.history-time {
  margin-top: 2px;
  color: rgba(0, 0, 0, 0.45);
  font-size: 12px;
}
@media (max-width: 400px) {
  .countdown-label {
    display: none;
  }
}
.history-modal .ant-modal-body {
  padding: 0 !important;
}
.reward-list-link {
  display: block;
  width: fit-content;

  margin: 10px auto 14px;
  padding: 7px 14px;

  font-size: 18px;
  font-weight: 700;
  line-height: 1.3;

  color: #00507a;
  text-align: center;
  text-decoration: none;

  border: 1px solid rgba(0, 80, 122, 0.35);
  border-radius: 8px;

  background: #fff;

  box-shadow:
    0 3px 8px rgba(0, 0, 0, 0.14);

  transition: all 0.2s ease;
}

.reward-list-link:hover {
  color: #006b99;
  text-decoration: underline;
  text-underline-offset: 3px;

  border-color: #006b99;

  box-shadow:
    0 5px 12px rgba(0, 0, 0, 0.18);

  transform: translateY(-1px);
}

@media (max-width: 400px) {
  .reward-list-link {
    font-size: 16px;
  }
}
.submit-field-error {
  position: relative;
}

.submit-field-error /deep/ input {
  border: 1px solid #f5222d !important;
}

.submit-field-error /deep/ .ant-upload,
.submit-field-error /deep/ .ant-upload-select,
.submit-field-error /deep/ .upload-box,
.submit-field-error /deep/ .upload-image {
  border: 1px solid #f5222d !important;
}
.submit-field-error .ant-form-item-label > label {
  color: #f5222d !important;
}

.submit-field-error .ant-input {
  border-color: #f5222d !important;
}

.submit-field-error .ant-input:hover,
.submit-field-error .ant-input:focus {
  border-color: #f5222d !important;
  box-shadow: 0 0 0 2px rgba(245, 34, 45, 0.12) !important;
}

.submit-field-error .ant-calendar-picker-input {
  border-color: #f5222d !important;
}
</style>
